// extracted by mini-css-extract-plugin
export default {"profile":"ProfileDetails__profile___T5cgf","loadingMessage":"ProfileDetails__loadingMessage___29h3_"};